import React from 'react';

import Axios from '../axios';
import FormConsumer, { buildFormPayloadFromQuestions, isDriveLicenseQuestion } from './FormConsumers';
import { Flex, Text, ActionNote } from '../components';
import { Button } from '../styles';
import { toFormData } from '../../../assets/js/utils';
import { PageTitle } from '../biz-components/page-title';

class FillFormAction extends React.Component {
  constructor(props) {
    const { action } = props;
    super(props);
    const formSubmission = props.action.assignees[0].form_submission;
    const questionsWithAnswers = action.assignees[0].form_submission
      ? action.assignees[0].form_submission.questions.map((question) => {
        if (question.answer) return question;
        const { question_type: questionType } = question;
        const answer = {
          answer: {
            [question.id]: (() => {
              let value = '';
              if (questionType === 'multiple_selection') {
                value = [];
              }
              return value;
            })(),
          },
        };
        if (question.question_type === 'dl') {
          answer.answer.state_code = '';
        }
        return {
          ...question,
          answer,
        };
      }) : [];
    this.formConsumer = React.createRef();
    this.state = {
      questions: questionsWithAnswers,
      actionStatus: action.status,
      badAnswers: formSubmission.bad_answers,
    };
    this.isOnboardingV2 = isOnboardingV2 === 'true';
  }

  handleEmployeeSubmitForm() {
    if (this.formConsumer && this.formConsumer.current) {
      this.formConsumer.current.validate((error) => {
        if (error) return;
        // No error, proceed to submit
        // 1. prepare form payload
        // 2. config HTTP request
        // 3. submit to server
        // 4. handle server response

        const formSubmission = this.props.action.assignees[0].form_submission;

        let redoQuestions;
        if (formSubmission.status === 'redo') {
          const redoQuestionsIds = Object.keys(formSubmission.bad_answers).map((k) => Number(k));
          redoQuestions = this.state.questions.filter((q) => redoQuestionsIds.includes(q.id));
        }

        const formPayload = buildFormPayloadFromQuestions(redoQuestions || this.state.questions);

        const payload = {
          onboarding_form_submission: {
            answers: formPayload,
          },
        };

        const config = {
          'Access-Control-Allow-Origin': '*',
        };

        const digestKey = this.props.action.assignees[0].form_submission.digest_key;
        this.setState({ isSubmitting: true });
        Axios.put(APIURL.replace(':digest_key', digestKey), toFormData(payload), config)
          .then((data) => {
            this.setState({ isSubmitting: false });
            if (this.props.onSubmitFormSuccess) {
              this.props.onSubmitFormSuccess(data);
            }
          })
          .catch(() => {
            this.setState({ isSubmitting: false });
          });
      });
    }
  }

  renderSubmitButtons() {
    let disabled = false;
    let disableNote = '';
    const { actionStatus } = this.state;

    if (this.props.previewMode) {
      // display the action anyway
      disabled = true;
      disableNote = 'Cannot submit form in preview mode.';
    } else if (actionStatus !== 'not_started' && actionStatus !== 'in_progress' && actionStatus !== 'redo') {
      disabled = true;
      disableNote = 'This step has been completed.';
    } else if (companyStaff && companyStaff.id) {
      disabled = true;
      disableNote = 'This form should be submitted by employee.';
    }

    let buttonText = 'Submit';
    if (actionStatus === 'in_progress' || actionStatus === 'redo') {
      buttonText = 'Re-submit';
    }
    if (this.state.isSubmitting) {
      buttonText += 'ting';
    }

    return (
      <Flex column alignItems="flex-end">
        <Button
          disabled={disabled}
          onClick={this.handleEmployeeSubmitForm.bind(this)}
          loading={this.state.isSubmitting}
        >
          {buttonText}
        </Button>
        {disabled && <ActionNote text={disableNote} />}
      </Flex>
    );
  }

  handleQuestionChange({ question, value }) {
    const questions = this.state.questions.map((q) => {
      if (q.id !== question.id) return q;
      let answer;
      if (isDriveLicenseQuestion(question) || question.question_type === 'attachment') {
        answer = {
          ...q.answer,
          answer: {
            ...q.answer.answer,
            ...value,
          },
        };
      } else {
        answer = {
          ...q.answer,
          answer: {
            ...q.answer.answer,
            [q.id]: value,
          },
        };
      }
      const updatedQuestion = {
        ...q,
        answer,
      };
      return updatedQuestion;
    });
    const badAnswers = { ...this.state.badAnswers };
    delete badAnswers[question.id];
    this.setState({ questions, badAnswers });
  }

  render() {
    let { questions, actionStatus, badAnswers } = this.state;
    const { companyStaff, action } = this.props;
    const formSubmission = this.props.action.assignees[0].form_submission;

    if (formSubmission.status === 'redo') {
      // only display the wrong questions
      const wrongQuestionIds = Object.keys(formSubmission.bad_answers).map((k) => Number(k));
      questions = questions.filter((question) => wrongQuestionIds.indexOf(question.id) !== -1);
    }

    return (
      <Flex column>
        {
          this.isOnboardingV2 && <PageTitle title={this.props.action.module_name} />
        }
        <Flex column style={this.isOnboardingV2 ? { paddingLeft: '4px', paddingRight: '4px' } : { width: "310px", margin: "auto" }}>
          {
            !this.isOnboardingV2
              && <Flex mb={20}><Text fontSize="22px" bold>{this.props.title}</Text></Flex>
          }
          <FormConsumer
            questions={questions}
            onQuestionChange={this.handleQuestionChange.bind(this)}
            ref={this.formConsumer}
            useOriginalQuestionTitle
            {...this.props.viewResultAsManager && { reviewActions: [] }}
            badAnswers={badAnswers}
          />

          {/* render buttons base on different status */}
          {/* case 1: employee submit form */}
          {this.renderSubmitButtons()}
        </Flex>
      </Flex>
    );
  }
}

export default FillFormAction;
